import { render } from "./PiarContent.vue?vue&type=template&id=5918da16&ts=true"
import script from "./PiarContent.vue?vue&type=script&lang=ts"
export * from "./PiarContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__